import React from "react";
import styled from "styled-components";
import { Box, HeadingStyledSm, SpanStyled, TextStyled } from "../../styled/Elements";
import { useTranslation } from "react-i18next";


const Notification = (props) => {
    const {t} = useTranslation();
    return (
        <MNListWrapper>
            <Box className="notifyListImg">
                <img src={props.userImg} />
            </Box>
            <Box className="userNotifyDetail">
                <Box className="notifyTitleName">
                    <HeadingStyledSm
                        size="16px"
                        color="var(--darkGrey)"
                    >
                        {props.userName}
                    </HeadingStyledSm>
                    <TextStyled
                        size="15px"
                        color="var(--lightGrey)"
                        dangerouslySetInnerHTML={{ __html: t(props.status) }}
                        
                    ></TextStyled>
                </Box>

                <SpanStyled
                    size="15px"
                    color="var(--lightGrey2)"
                >
                    5 {t(props.messageTime)}
                </SpanStyled>
            </Box>
        </MNListWrapper>
    );
}

export default Notification;

const MNListWrapper = styled.div`
  display: flex;
  padding: 11px 25px 10px 15px;
  gap: 12px;
  align-items: flex-start;
  border-bottom: 1px solid var(--border);
  .notifyListImg {
    max-width: 48px;
    min-width: 48px;
    border-radius: 50%;
    overflow: hidden;
  }
  .userNotifyDetail {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
	
    
  }
  .notifyTitleName {
	display: flex;
	width: 100%;
	align-items: center;
	gap: 12px;
  }
  .titleName > *:not(button) {
    display: flex;
    width: 100%;
    white-space: normal;
    line-height: 16px;
  }
  
`;